import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { BOOK_MEETING_URL } from "../mock";

const ConnectCTA = () => {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-[#0F2A4A] px-8 py-16 text-center md:px-16 md:py-20">
            <div className="pointer-events-none absolute -left-16 -top-16 h-64 w-64 rounded-full bg-white/[0.04] blur-2xl" />
            <div className="pointer-events-none absolute -bottom-16 -right-10 h-64 w-64 rounded-full bg-[#E4545F]/10 blur-2xl" />
            <h2 className="relative font-serif-display text-3xl leading-tight text-white md:text-5xl">
              Let’s connect.
            </h2>
            <p className="relative mx-auto mt-5 max-w-xl text-lg font-light text-white/70">
              Whether you are entering India, expanding globally, or building a
              trade programme — we’d love to talk.
            </p>
            <div className="relative mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <a
                href={BOOK_MEETING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-white px-8 py-3.5 text-sm font-semibold text-[#0F2A4A] transition-all duration-200 hover:-translate-y-0.5 hover:bg-white/90"
              >
                Book a Meeting <ArrowRight className="h-4 w-4" />
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 rounded-full border border-white/30 px-8 py-3.5 text-sm font-semibold text-white transition-all duration-200 hover:border-white/60"
              >
                Contact us
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ConnectCTA;
